// extracted by mini-css-extract-plugin
export default {"row":"styles_row__7bQSU","active":"styles_active__pwGsA","cell":"styles_cell__NUYSi","headingCell":"styles_headingCell__5sqUG"};